import * as msal from '@azure/msal-browser';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { msalConfig } from './authConfig';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false
        }
    }
});
export const msalInstance =
    await msal.createStandardPublicClientApplication(msalConfig);
msalInstance.enableAccountStorageEvents();

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <App msalInstance={msalInstance} />
            </BrowserRouter>
        </QueryClientProvider>
    </React.StrictMode>
);
